import { useFormikContext } from 'formik';
import { IProjectFormValues } from 'views/Project/components/ProjectOverviewForm/index';
import {
  getSupportedLocaleMetadata,
  SupportedLocale,
} from '@sz/l10n';
import {
  Multiselect,
  TMultiselectOption,
} from '@spotted-zebra-uk/ui-components';
import styles from './LanguageForm.module.scss';

type LanguageFormProps = {
  title: string;
};

const LanguageForm = ({ title }: LanguageFormProps) => {
  const { setFieldValue, values } = useFormikContext<IProjectFormValues>();

  const handleChange = (values: TMultiselectOption[]) => {
    setFieldValue(
      'projectLocales',
      values.map(value => value.value)
    );
  };

  return (
    <div className={styles.container} data-testid="language-form__container">
      {title && <h2 className={styles.title}>{title}</h2>}
      <Multiselect
        id="project-languages-multiselect"
        name="Languages"
        value={values.projectLocales.map(value => ({
          label: getSupportedLocaleMetadata(SupportedLocale[value]).name
            .english,
          value: value,
        }))}
        options={Object.entries(SupportedLocale).map(([language, locale]) => ({
          id: language,
          label: getSupportedLocaleMetadata(locale).name.english,
          value: language,
        }))}
        onChange={handleChange}
      />
    </div>
  );
};

export default LanguageForm;
